(() => {
  if (window.okhomesInteractionsLoaded) return;
  window.okhomesInteractionsLoaded = true;

  const favoriteKey = 'okhomes:favorites:v1';
  const visitedKey = 'okhomes:visited:v1';
  const ratingKey = 'okhomes:personal-ratings:v1';
  const pathOf = value => {
    try { return new URL(String(value || ''), location.origin).pathname.replace(/\/$/, '') || '/'; }
    catch (_) { return String(value || '').split(/[?#]/)[0].replace(/\/$/, ''); }
  };
  const readSet = key => {
    try {
      const stored = JSON.parse(localStorage.getItem(key) || '[]');
      return new Set(Array.isArray(stored) ? stored.map(pathOf).filter(Boolean) : []);
    } catch (_) { return new Set(); }
  };
  const readRatings = () => {
    try {
      const stored = JSON.parse(localStorage.getItem(ratingKey) || '{}');
      return stored && typeof stored === 'object' && !Array.isArray(stored) ? stored : {};
    } catch (_) { return {}; }
  };
  const save = (key, value) => {
    try { localStorage.setItem(key, JSON.stringify(value)); } catch (_) {}
  };
  let floatingFavorite = null;
  let floatingFavoriteTimer = null;
  const positionFavoritesPanel = details => {
    if (!details.open) return;
    const panel = details.querySelector('.okhomes-header-favorites__panel');
    if (!panel) return;
    panel.style.setProperty('--favorite-panel-shift', '0px');
    const bounds = panel.getBoundingClientRect();
    const viewportWidth = document.documentElement.clientWidth;
    const shift = Math.max(12 - bounds.left, Math.min(0, viewportWidth - 12 - bounds.right));
    panel.style.setProperty('--favorite-panel-shift', shift + 'px');
  };
  const positionOpenFavorites = () => {
    document.querySelectorAll('[data-okhomes-favorites-panel][open]').forEach(positionFavoritesPanel);
  };
  const releaseFloatingFavorite = () => {
    if (!floatingFavorite || floatingFavorite.panel.open) return;
    const { panel, placeholder } = floatingFavorite;
    panel.classList.remove('is-favorites-floating');
    panel.style.removeProperty('--favorite-dock-left');
    panel.style.removeProperty('--favorite-panel-left');
    placeholder.replaceWith(panel);
    floatingFavorite = null;
  };
  const favoriteDestination = () => {
    const panel = floatingFavorite?.panel || Array.from(document.querySelectorAll('[data-okhomes-favorites-panel]')).find(candidate => {
      const bounds = candidate.querySelector('summary').getBoundingClientRect();
      return bounds.width > 0 && bounds.height > 0;
    });
    if (!panel) return null;
    const toggle = panel.querySelector('summary');
    const bounds = toggle.getBoundingClientRect();
    if (!floatingFavorite && (bounds.top < 0 || bounds.bottom > window.innerHeight)) {
      const placeholder = document.createElement('span');
      const panelBounds = panel.getBoundingClientRect();
      placeholder.style.cssText = 'display:block;flex:none;width:' + panelBounds.width + 'px;height:' + panelBounds.height + 'px';
      placeholder.setAttribute('aria-hidden', 'true');
      panel.before(placeholder);
      floatingFavorite = { panel, placeholder };
      panel.style.setProperty('--favorite-dock-left', Math.max(12, Math.min(window.innerWidth - 68, bounds.left)) + 'px');
      panel.style.setProperty('--favorite-panel-left', Math.min(0, Math.max(12, window.innerWidth - Math.min(320, window.innerWidth - 30) - 12) - Math.max(12, Math.min(window.innerWidth - 68, bounds.left))) + 'px');
      panel.classList.add('is-favorites-floating');
      document.body.append(panel);
      if (!panel.dataset.okhomesFloatingReady) {
        panel.dataset.okhomesFloatingReady = 'true';
        let panelWasOpen = panel.open;
        panel.addEventListener('toggle', () => {
          if (panelWasOpen && !panel.open && floatingFavorite?.panel === panel) releaseFloatingFavorite();
          panelWasOpen = panel.open;
        });
      }
    }
    if (floatingFavorite) {
      clearTimeout(floatingFavoriteTimer);
      floatingFavoriteTimer = setTimeout(releaseFloatingFavorite, 6000);
    }
    return toggle;
  };
  const favoriteFlight = button => {
    const target = favoriteDestination();
    if (!target || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    const source = button.querySelector('svg');
    if (!source) return;
    const origin = source.getBoundingClientRect();
    const heart = source.cloneNode(true);
    heart.classList.add('okhomes-favorite-flight');
    heart.setAttribute('aria-hidden', 'true');
    heart.style.left = origin.left + origin.width / 2 - 17 + 'px';
    heart.style.top = origin.top + origin.height / 2 - 17 + 'px';
    document.body.append(heart);
    setTimeout(() => {
      if (!target.isConnected) { heart.remove(); return; }
      const destination = target.getBoundingClientRect();
      const dx = destination.left + destination.width / 2 - origin.left - origin.width / 2;
      const dy = destination.top + destination.height / 2 - origin.top - origin.height / 2;
      const sideways = Math.max(-60, Math.min(60, dx * .2));
      const flight = heart.animate([
        { transform: 'translate(0,0) scale(1)', opacity: 1 },
        { transform: 'translate(' + (dx * .3 + sideways) + 'px,' + (dy * .4) + 'px) rotate(-14deg) scale(1.2)', offset: .4, opacity: 1 },
        { transform: 'translate(' + (dx * .8 + sideways) + 'px,' + (dy * .85) + 'px) rotate(8deg) scale(.9)', offset: .8, opacity: 1 },
        { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.55)', opacity: .7 }
      ], { duration: 950, easing: 'cubic-bezier(.3,.05,.25,1)', fill: 'forwards' });
      flight.onfinish = () => {
        heart.remove();
        target.animate([{ transform: 'scale(1)' }, { transform: 'scale(1.2)', offset: .4 }, { transform: 'scale(1)' }], { duration: 380, easing: 'ease-out' });
      };
      flight.oncancel = () => heart.remove();
    }, floatingFavorite ? 200 : 0);
  };
  const favoritePop = button => {
    favoriteFlight(button);
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    button.classList.remove('is-favorite-popping');
    void button.offsetWidth;
    button.classList.add('is-favorite-popping');
    window.setTimeout(() => button.classList.remove('is-favorite-popping'), 850);

    const bounds = button.getBoundingClientRect();
    const burst = document.createElement('span');
    burst.className = 'okhomes-favorite-burst';
    burst.setAttribute('aria-hidden', 'true');
    burst.style.left = (bounds.left + bounds.width / 2) + 'px';
    burst.style.top = (bounds.top + bounds.height / 2) + 'px';

    const label = document.createElement('span');
    label.className = 'okhomes-favorite-burst__label';
    label.textContent = '¡GUARDADO!';
    burst.appendChild(label);

    [
      ['♥', -48, -44, '#e97080'],
      ['✦', -24, -70, '#e6ae35'],
      ['♥', 25, -65, '#198b3b'],
      ['✦', 49, -35, '#e6ae35'],
      ['♥', -8, -85, '#e97080']
    ].forEach(([symbol, dx, dy, color], index) => {
      const particle = document.createElement('span');
      particle.className = 'okhomes-favorite-burst__particle';
      particle.textContent = symbol;
      particle.style.setProperty('--dx', dx + 'px');
      particle.style.setProperty('--dy', dy + 'px');
      particle.style.setProperty('--particle-color', color);
      particle.style.setProperty('--delay', (index * 45) + 'ms');
      burst.appendChild(particle);
    });
    document.body.appendChild(burst);
    window.setTimeout(() => burst.remove(), 1100);
  };
  let favorites = readSet(favoriteKey);
  let visited = readSet(visitedKey);
  let ratings = readRatings();

  const paintState = root => {
    const path = pathOf(root.dataset.productUrl);
    const button = root.querySelector('[data-okhomes-favorite]');
    const badge = root.querySelector('[data-okhomes-visited]') || root.closest('.card-wrapper')?.querySelector('.okhomes-card-gallery__visited');
    const active = favorites.has(path);
    button.setAttribute('aria-pressed', String(active));
    button.setAttribute('aria-label', active ? 'Eliminar de favoritos' : 'Guardar en favoritos');
    if (root.classList.contains('okhomes-state--product')) {
      root.querySelector('.okhomes-state__favorite-label').textContent = active ? 'GUARDADO EN FAVORITOS' : 'GUARDAR EN FAVORITOS';
    }
    if (badge) badge.hidden = !visited.has(path);
  };

  const priceAlertSeen = new Set();
  const showFavoritePriceDrop = (path, product) => {
    const previous = Number(favoritePriceBaseline[path]?.price);
    const current = Number(product.price) / 100;
    if (!favorites.has(path) || !Number.isFinite(previous) || previous <= 0 || !Number.isFinite(current) || current <= 0 || current >= previous || priceAlertSeen.has(path)) return;
    priceAlertSeen.add(path);
    let panel = document.getElementById('okhomes-favorite-price-alerts');
    if (!panel) {
      panel = document.createElement('section');
      panel.id = 'okhomes-favorite-price-alerts';
      panel.setAttribute('aria-label', 'Avisos de bajada de precio');
      panel.setAttribute('aria-live', 'polite');
      panel.style.cssText = 'position:fixed;bottom:20px;right:16px;width:min(360px,calc(100vw - 32px));max-height:45vh;overflow:auto;z-index:1000;background:white;color:#174b32;border:2px solid #198b3b;border-radius:18px;padding:18px;box-shadow:0 8px 28px #0003';
      const close = document.createElement('button');
      close.type = 'button'; close.textContent = 'Cerrar ×';
      close.style.cssText = 'float:right;min-height:44px;background:none;border:0;color:inherit;cursor:pointer';
      close.addEventListener('click', () => panel.remove());
      panel.appendChild(close);
      document.body.appendChild(panel);
    }
    const item = document.createElement('a');
    item.href = path;
    item.style.cssText = 'display:block;color:inherit;text-decoration:none;padding:8px 0;clear:both';
    const title = document.createElement('strong');
    title.textContent = 'Uno de tus favoritos ha bajado de precio';
    const details = document.createElement('p');
    details.textContent = product.title || 'Propiedad';
    const money = value => new Intl.NumberFormat('es-ES', {style:'currency',currency:'EUR',maximumFractionDigits:0}).format(value);
    const before = document.createElement('p');
    before.textContent = 'Antes: ' + money(previous);
    before.style.cssText = 'margin:8px 0;font-size:.95em';
    const now = document.createElement('strong');
    now.textContent = 'AHORA: ' + money(current);
    now.style.cssText = 'display:block;font-size:1.16em;font-weight:800;color:#176b36;margin:8px 0';
    const action = document.createElement('span');
    action.textContent = 'Ver propiedad →';
    action.style.cssText = 'display:block;color:#176b36;text-decoration:underline;margin-top:12px';
    item.append(title, details, before, now, action); panel.appendChild(item);
  };

  const favoriteProducts = new Map();
  const getPublishedFavorite = path => {
    let request = favoriteProducts.get(path);
    if (request) return request;
    const handle = path.split('/').pop();
    const root = window.Shopify?.routes?.root || '/';
    request = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin', cache: 'no-store' })
      .then(response => {
        if (response.status === 404 || response.status === 410) {
          favorites.delete(path); selectedCompare.delete(path); delete compareDetails[path];
          save(favoriteKey, [...favorites]); save(compareKey, compareDetails);
          document.querySelectorAll('[data-okhomes-favorite-path]').forEach(link => {
            if (link.dataset.okhomesFavoritePath === path) link.closest('li')?.remove();
          });
          document.querySelectorAll('[data-okhomes-favorites-panel]').forEach(panel => {
            const count = [...favorites].filter(path => path.startsWith('/products/')).length;
            panel.querySelector('[data-okhomes-favorites-count]').textContent = String(count);
            panel.querySelector('summary').setAttribute('aria-label', 'Favoritos, ' + count + (count === 1 ? ' propiedad guardada' : ' propiedades guardadas'));
            panel.querySelector('[data-okhomes-favorites-empty]').hidden = count > 0;
            updateCompareControls(panel);
          });
          return null;
        }
        if (!response.ok) return null;
        return response.json();
      }).catch(() => null).finally(() => favoriteProducts.delete(path));
    favoriteProducts.set(path, request);
    return request;
  };
  const loadFavoriteCards = panel => {
    const requests = [];
    panel.querySelectorAll('[data-okhomes-favorite-path]').forEach(link => {
      const path = link.dataset.okhomesFavoritePath;
      const item = link.closest('li');
      item.hidden = true;item.style.setProperty('display','none','important');
      const request = getPublishedFavorite(path);
      requests.push(request);
      request.then(product => {
        if (!product || !link.isConnected) return;
        item.hidden = false;item.style.removeProperty('display');
        showFavoritePriceDrop(path, product);
        const title = link.querySelector('.okhomes-header-favorites__title');
        const thumb = link.querySelector('.okhomes-header-favorites__thumb');
        const price = link.querySelector('.okhomes-header-favorites__price');
        title.textContent = product.title || title.textContent;
        const currentPrice = typeof product.price === 'number' ? product.price / 100 : 0;
        const previousPrice = Number(favoritePriceBaseline[path]?.price);
        const reduced = currentPrice > 0 && (
          Number(product.compare_at_price) > Number(product.price) ||
          (Number.isFinite(previousPrice) && previousPrice > currentPrice) ||
          Number(compareDetails[path]?.reducedAtPrice) === currentPrice
        );
        link.closest('li').dataset.okhomesReduced = reduced ? 'true' : 'false';
        let badge = link.querySelector('[data-okhomes-reduced-label]');
        if (reduced && !badge) {
          badge = document.createElement('strong');
          badge.dataset.okhomesReducedLabel = '';
          badge.textContent = '¡Ha bajado de precio!';
          badge.style.cssText = 'display:block;color:#18883c;font-size:0.85em;margin-top:4px';
          price.parentElement.append(badge);
        } else if (!reduced && badge) badge.remove();
        const list = link.closest('[data-okhomes-favorites-list]');
        if (list) {
          [...list.children].sort((a, b) =>
            Number(b.dataset.okhomesReduced === 'true') - Number(a.dataset.okhomesReduced === 'true') ||
            Number(a.dataset.okhomesFavoriteOrder) - Number(b.dataset.okhomesFavoriteOrder)
          ).forEach(item => list.append(item));
        }
        compareDetails[path] = { ...(compareDetails[path] || {}), reducedAtPrice: reduced ? currentPrice : null, title: product.title || compareDetails[path]?.title || '', price: typeof product.price === 'number' ? product.price / 100 : compareDetails[path]?.price || 0, image: compareDetails[path]?.image || product.featured_image || '' };
        save(compareKey, compareDetails);
        if (product.featured_image) {
          const image = document.createElement('img');
          const source = new URL(product.featured_image, location.origin);
          source.searchParams.set('width', '160');
          image.src = source.href;
          image.alt = 'Foto principal de ' + (product.title || 'la propiedad');
          image.width = 74;
          image.height = 62;
          image.loading = 'lazy';
          thumb.replaceChildren(image);
        }
        if (typeof product.price === 'number') {
          price.textContent = new Intl.NumberFormat('es-ES', { maximumFractionDigits: 0 }).format(product.price / 100) + ' €' + (product.price === 0 ? ' · RESERVADO' : '');
        }
      });
    });
    return Promise.all(requests);
  };
  const compareKey = 'okhomes:compare-details:v1';
  const compareDetails = (() => { try { return JSON.parse(localStorage.getItem(compareKey) || '{}') || {}; } catch (_) { return {}; } })();
  const favoritePriceBaseline = JSON.parse(JSON.stringify(compareDetails));
  const captureCompareDetails = () => {
    document.querySelectorAll('[data-okhomes-compare-info]').forEach(node => {
      const path = pathOf(node.dataset.productUrl);
      if (!path) return;
      showFavoritePriceDrop(path, {title: node.dataset.title || '', price: (Number(node.dataset.price) || 0) * 100});
      compareDetails[path] = {
        title: node.dataset.title || '', price: Number(node.dataset.price) || 0, reference: node.dataset.reference || '',
        place: node.dataset.place || '', rooms: node.dataset.rooms || '',
        baths: node.dataset.baths || '', area: node.dataset.area || '', areaKind: node.dataset.areaKind || 'construida',
        image: node.dataset.image || ''
      };
    });
    save(compareKey, compareDetails);
  };
  const selectedCompare = new Set();
  const compareDialog = document.createElement('dialog');
  compareDialog.className = 'okhomes-compare';
  compareDialog.setAttribute('aria-label', 'Comparar propiedades favoritas');
  const renderCompare = () => {
    compareDialog.replaceChildren();
    const title = document.createElement('h2');
    title.textContent = 'COMPARA TUS FAVORITAS';
    const close = document.createElement('button');
    close.type = 'button'; close.className = 'okhomes-compare__close';
    close.textContent = 'Cerrar ×';
    close.addEventListener('click', () => compareDialog.close());
    const grid = document.createElement('div');
    grid.className = 'okhomes-compare__grid';
    [...selectedCompare].forEach(path => {
      const data = compareDetails[path] || {};
      const card = document.createElement('article');
      card.className = 'okhomes-compare__card';
      if (data.image) {
        const img = document.createElement('img');
        img.src = data.image; img.alt = ''; img.loading = 'lazy'; card.append(img);
      }
      const link = document.createElement('a');
      link.href = path; link.textContent = data.title || decodeURIComponent(path.split('/').pop()).replace(/-/g, ' ');
      card.append(link);
      const visit = document.createElement('a');
      visit.className = 'okhomes-compare__visit';
      visit.href = 'https://wa.me/34622238083?text=' + encodeURIComponent('Hola, quiero organizar una visita a la propiedad ' + (data.reference || data.title || 'seleccionada') + ': ' + location.origin + path);
      visit.target = '_blank'; visit.rel = 'noopener noreferrer'; visit.textContent = 'Organizar visita ↗';
      card.append(visit);
      [['Precio', data.price ? new Intl.NumberFormat('es-ES').format(data.price) + ' €' : 'Reservado'],
        ['Localidad', data.place || 'Sin dato'], ['Habitaciones', data.rooms || 'Sin dato'],
        ['Baños', data.baths || 'Sin dato'], ['Superficie', data.area ? data.area + ' m²' + (data.areaKind === 'parcela' ? ' parcela' : '') : 'Sin dato']].forEach(([label, value]) => {
        const row = document.createElement('p');
        const strong = document.createElement('strong');
        strong.textContent = label + ': '; row.append(strong, document.createTextNode(value)); card.append(row);
      });
      grid.append(card);
    });
    const share = document.createElement('a');
    share.className = 'okhomes-compare__share';
    share.href = 'https://wa.me/?text=' + encodeURIComponent('Estas propiedades de OKHOMES me gustan:\n' + [...selectedCompare].map(path => { const data = compareDetails[path] || {}; return '• ' + (data.reference || data.title || 'Propiedad') + ' — ' + location.origin + path; }).join('\n'));
    share.target = '_blank'; share.rel = 'noopener noreferrer'; share.textContent = 'Compartir selección por WhatsApp ↗';
    compareDialog.append(title, close, grid, share);
  };
  const updateCompareControls = panel => {
    const button = panel.querySelector('[data-okhomes-compare-open]');
    if (!button) return;
    button.disabled = selectedCompare.size < 2;
    button.textContent = 'COMPARAR (' + selectedCompare.size + '/3)';
    panel.querySelectorAll('[data-okhomes-compare-select]').forEach(box => {
      box.checked = selectedCompare.has(box.value);
      box.disabled = !box.checked && selectedCompare.size >= 3;
    });
  };
  const paintFavoritesHeader = () => {
    document.querySelectorAll('[data-okhomes-favorites-panel]').forEach(panel => {
      const count = panel.querySelector('[data-okhomes-favorites-count]');
      const toggle = panel.querySelector('summary');
      const list = panel.querySelector('[data-okhomes-favorites-list]');
      const empty = panel.querySelector('[data-okhomes-favorites-empty]');
      const paths = [...favorites].filter(path => path.startsWith('/products/'));
      count.textContent = String(paths.length);
      toggle.setAttribute('aria-label', 'Favoritos, ' + paths.length + (paths.length === 1 ? ' propiedad guardada' : ' propiedades guardadas'));
      empty.hidden = paths.length > 0;
      const items = paths.map(path => {
        const item = document.createElement('li');
        item.hidden = true;item.style.setProperty('display','none','important');
        const link = document.createElement('a');
        const thumb = document.createElement('span');
        const info = document.createElement('span');
        const title = document.createElement('span');
        const price = document.createElement('small');
        link.href = path;
        link.dataset.okhomesFavoritePath = path;
        link.className = 'okhomes-header-favorites__card';
        thumb.className = 'okhomes-header-favorites__thumb';
        thumb.setAttribute('aria-hidden', 'true');
        thumb.textContent = '⌂';
        title.className = 'okhomes-header-favorites__title';
        title.textContent = decodeURIComponent(path.split('/').pop() || '').replace(/[-_]+/g, ' ').toUpperCase();
        price.className = 'okhomes-header-favorites__price';
        info.append(title, price);
        link.append(thumb, info);
        item.append(link);
        return item;
      });
      list.replaceChildren(...items);
      paths.forEach((path, index) => {
        const item = list.children[index];
        item.dataset.okhomesFavoriteOrder = String(index);
        const label = document.createElement('label');
        label.className = 'okhomes-compare__select';
        const box = document.createElement('input');
        box.type = 'checkbox'; box.value = path; box.dataset.okhomesCompareSelect = '';
        const caption = document.createElement('span');
        caption.textContent = 'Comparar';
        label.append(box, caption); item.append(label);
      });
      selectedCompare.forEach(path => { if (!paths.includes(path)) selectedCompare.delete(path); });
      let compareButton = panel.querySelector('[data-okhomes-compare-open]');
      if (!compareButton) {
        compareButton = document.createElement('button');
        compareButton.type = 'button'; compareButton.className = 'okhomes-compare__open';
        compareButton.dataset.okhomesCompareOpen = '';
        panel.querySelector('.okhomes-header-favorites__panel')?.append(compareButton);
      }
      updateCompareControls(panel);
      if (panel.open) loadFavoriteCards(panel);
    });
  };
  const paintRating = root => {
    const value = Number(ratings[pathOf(root.dataset.productUrl)]) || 0;
    root.querySelectorAll('[data-score]').forEach(button => {
      const score = Number(button.dataset.score);
      button.textContent = score <= value ? '★' : '☆';
      button.setAttribute('aria-pressed', String(score === value));
    });
    const status = root.querySelector('.okhomes-property-rating-status');
    status.textContent = value ? value + ',0 / 5' : '— / 5';
    status.setAttribute('aria-label', value ? 'Tu valoración personal: ' + value + ' de 5. Solo en este dispositivo.' : 'Aún no has valorado esta propiedad.');
  };
  const initialize = root => {
    if (!root || root.dataset.okhomesInitialized) return;
    root.dataset.okhomesInitialized = 'true';
    if (root.matches('[data-okhomes-state]')) paintState(root);
    if (root.matches('[data-okhomes-rating]')) paintRating(root);
  };
  const initializeGallery = gallery => {
    if (gallery.dataset.okhomesGalleryReady) return;
    gallery.dataset.okhomesGalleryReady = 'true';
    const track = gallery.querySelector('[data-okhomes-gallery-track]');
    const current = gallery.querySelector('[data-okhomes-gallery-current]');
    if (!track || !current) return;
    let framePending = false;
    const update = () => {
      framePending = false;
      const index = Math.round(track.scrollLeft / Math.max(1, track.clientWidth));
      // Keep the full gallery available while loading only the current and adjacent photos.
      for (let adjacent = Math.max(0, index - 1); adjacent <= Math.min(track.children.length - 1, index + 1); adjacent++) {
        const slide = track.children[adjacent];
        if (!slide.dataset.okhomesImageUrl) continue;
        const image = document.createElement('img');
        const source = new URL(slide.dataset.okhomesImageUrl, location.origin);
        image.src = source.href;
        image.alt = slide.dataset.okhomesImageAlt || '';
        image.width = Number(slide.dataset.okhomesImageWidth) || 720;
        image.height = Number(slide.dataset.okhomesImageHeight) || 480;
        image.loading = 'lazy';
        image.decoding = 'async';
        image.sizes = track.querySelector('img')?.sizes || '90vw';
        image.srcset = [360, 720, 1066].map(width => {
          const variant = new URL(source.href);
          variant.searchParams.set('width', String(width));
          return variant.href + ' ' + width + 'w';
        }).join(', ');
        slide.appendChild(image);
        delete slide.dataset.okhomesImageUrl;
        delete slide.dataset.okhomesImageAlt;
        delete slide.dataset.okhomesImageWidth;
        delete slide.dataset.okhomesImageHeight;
      }
      const value = String(Math.min(track.children.length, Math.max(1, index + 1)));
      if (current.textContent !== value) current.textContent = value;
    };
    const scheduleUpdate = () => {
      if (framePending) return;
      framePending = true;
      requestAnimationFrame(update);
    };
    let gestureStart = null;
    const ignoreSwipeClick = () => {
      gallery.dataset.okhomesIgnoreClick = 'true';
      setTimeout(() => { delete gallery.dataset.okhomesIgnoreClick; }, 450);
    };
    track.addEventListener('touchstart', event => {
      gestureStart = event.touches.length === 1 ? {
        x: event.touches[0].clientX,
        y: event.touches[0].clientY,
        left: track.scrollLeft
      } : null;
    }, { passive: true });
    track.addEventListener('touchend', event => {
      if (!gestureStart || !event.changedTouches.length) return;
      const touch = event.changedTouches[0];
      const dx = Math.abs(touch.clientX - gestureStart.x);
      const dy = Math.abs(touch.clientY - gestureStart.y);
      if (Math.abs(track.scrollLeft - gestureStart.left) > 8 || (dx > 12 && dx > dy * 1.2)) ignoreSwipeClick();
      gestureStart = null;
    }, { passive: true });
    track.addEventListener('touchcancel', () => { gestureStart = null; }, { passive: true });
    gallery.addEventListener('click', event => {
      if (gallery.dataset.okhomesIgnoreClick && event.target.closest('.okhomes-card-gallery__slide')) {
        event.preventDefault();
        event.stopPropagation();
        delete gallery.dataset.okhomesIgnoreClick;
      }
    }, true);
    track.addEventListener('scroll', scheduleUpdate, { passive: true });
    window.addEventListener('resize', scheduleUpdate, { passive: true });
    update();
  };
  const initializeWithin = base => {
    if (base.matches?.('[data-okhomes-gallery]')) initializeGallery(base);
    base.querySelectorAll?.('[data-okhomes-gallery]').forEach(initializeGallery);
    if (base.matches?.('[data-okhomes-state], [data-okhomes-rating]')) initialize(base);
    base.querySelectorAll?.('[data-okhomes-state], [data-okhomes-rating]').forEach(initialize);
  };
  const refresh = () => {
    document.querySelectorAll('[data-okhomes-state]').forEach(paintState);
    document.querySelectorAll('[data-okhomes-rating]').forEach(paintRating);
    paintFavoritesHeader();
  };
  const start = () => {
    initializeWithin(document);
    captureCompareDetails();
    document.body.append(compareDialog);
    paintFavoritesHeader();
    document.querySelectorAll('[data-okhomes-favorites-panel]').forEach(panel => {
      panel.addEventListener('toggle', () => {
        if (panel.open) { positionFavoritesPanel(panel); loadFavoriteCards(panel); }
      });
    });
    window.addEventListener('resize', positionOpenFavorites);
    const productPath = document.querySelector('.okhomes-state--product')?.dataset.productUrl;
    if (productPath) {
      const path = pathOf(productPath);
      if (!visited.has(path)) {
        visited.add(path);
        save(visitedKey, [...visited]);
        document.querySelectorAll('.okhomes-state--product').forEach(paintState);
      }
    }
    new MutationObserver(mutations => {
      mutations.forEach(mutation => mutation.addedNodes.forEach(node => {
        if (node.nodeType === 1) { initializeWithin(node); if (node.matches?.('[data-okhomes-compare-info]') || node.querySelector?.('[data-okhomes-compare-info]')) captureCompareDetails(); }
      }));
    }).observe(document.body, { childList: true, subtree: true });
  };
  document.addEventListener('click', event => {
    const galleryArrow = event.target.closest('[data-okhomes-gallery-step]');
    if (galleryArrow) {
      event.preventDefault();
      event.stopPropagation();
      const track = galleryArrow.closest('[data-okhomes-gallery]')?.querySelector('[data-okhomes-gallery-track]');
      if (track) track.scrollBy({ left: Number(galleryArrow.dataset.okhomesGalleryStep) * track.clientWidth, behavior: 'smooth' });
      return;
    }
    const compareOpen = event.target.closest('[data-okhomes-compare-open]');
    if (compareOpen) {
      event.preventDefault(); compareOpen.disabled = true;
      const paths = [...selectedCompare];
      Promise.all(paths.map(path => getPublishedFavorite(path))).then(products => {
        paths.forEach((path, index) => { if (!products[index]) selectedCompare.delete(path); });
        const panel = compareOpen.closest('[data-okhomes-favorites-panel]');
        if (panel) updateCompareControls(panel);
        if (selectedCompare.size < 2) return;
        captureCompareDetails(); renderCompare(); compareDialog.showModal();
      });
      return;
    }
    const compareSelect = event.target.closest('[data-okhomes-compare-select]');
    if (compareSelect) {
      if (compareSelect.checked && selectedCompare.size < 3) selectedCompare.add(compareSelect.value);
      else selectedCompare.delete(compareSelect.value);
      updateCompareControls(compareSelect.closest('[data-okhomes-favorites-panel]'));
      return;
    }
    const share = event.target.closest('[data-okhomes-share]');
    if (share) {
      event.preventDefault();
      const url = share.dataset.shareUrl || location.href;
      const title = share.dataset.shareTitle || document.title;
      const status = share.closest('.okhomes-card-actions, .okhomes-property-top-actions')?.querySelector('.okhomes-card-actions__status, .okhomes-property-share-status');
      (async () => {
        if (navigator.share) {
          try { await navigator.share({ title, url }); return; }
          catch (error) { if (error.name === 'AbortError') return; }
        }
        try { await navigator.clipboard.writeText(url); if (status) status.textContent = 'Enlace copiado'; }
        catch (error) { window.prompt('Copia el enlace:', url); }
      })();
      return;
    }
    const favorite = event.target.closest('[data-okhomes-favorite]');
    if (favorite) {
      event.preventDefault();
      event.stopPropagation();
      const root = favorite.closest('[data-okhomes-state]');
      const path = pathOf(root?.dataset.productUrl);
      if (!path) return;
      const adding = !favorites.has(path);
      if (adding) favorites.add(path); else favorites.delete(path);
      save(favoriteKey, [...favorites]);
      document.querySelectorAll('[data-okhomes-state]').forEach(paintState);
      captureCompareDetails();
      paintFavoritesHeader();
      if (adding) favoritePop(favorite);
      return;
    }
    const scoreButton = event.target.closest('[data-okhomes-rating] [data-score]');
    if (scoreButton) {
      const root = scoreButton.closest('[data-okhomes-rating]');
      ratings[pathOf(root.dataset.productUrl)] = Number(scoreButton.dataset.score);
      save(ratingKey, ratings);
      paintRating(root);
    }
  });
  document.addEventListener('click', event => {
    document.querySelectorAll('[data-okhomes-favorites-panel][open]').forEach(panel => {
      if (!panel.contains(event.target)) panel.open = false;
    });
  });
  document.addEventListener('keydown', event => {
    if (event.key === 'Escape') document.querySelectorAll('[data-okhomes-favorites-panel][open]').forEach(panel => { panel.open = false; });
  });
  window.addEventListener('storage', event => {
    if (event.key === favoriteKey) favorites = readSet(favoriteKey);
    if (event.key === visitedKey) visited = readSet(visitedKey);
    if (event.key === ratingKey) ratings = readRatings();
    if ([favoriteKey, visitedKey, ratingKey].includes(event.key)) refresh();
  });
  window.addEventListener('pageshow', event => {
    if (!event.persisted) return;
    window.location.reload();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, { once: true });
  else start();

  const checkFavoritePrices = () => {
    const panel = document.querySelector('[data-okhomes-favorites-panel]');
    if (panel && favorites.size) loadFavoriteCards(panel);
  };
  if ('requestIdleCallback' in window) window.requestIdleCallback(checkFavoritePrices, {timeout:5000});
  else window.setTimeout(checkFavoritePrices, 3000);
})();

